{
  "datatable": {
    "rowsPerPage": "ჩანაწერი გვერდზე"
  },
  "department": {
    "addDepartment": "დეპარტამენტის დამატება",
    "confirms": {
      "deleteText": "ამ დეპარტამენტის ყველა მომხმარებელი, პროცედურა, სასწავლო ობიექტი, კვლევა და მოწყობილობა გადანაწილდება ქვემოთ არჩეულ დეპარტამენტზე. ეს შეუქცევადია.",
      "deleteTitle": "წავშალოთ {name}?",
      "restoreText": "ეს ხელახლა გახდის დეპარტამენტს ხილულს და აღადგენს წვდომას პერსონალისთვის.",
      "restoreTitle": "აღვადგინოთ {name}?"
    },
    "createNewDepartment": "ახალი დეპარტამენტის შექმნა",
    "deletedDepartment": "დეპარტამენტი წაშლილია",
    "deleteDepartment": "დეპარტამენტის წაშლა",
    "departmentAdmin": "დეპარტამენტის ადმინისტრატორი",
    "departmentName": "დეპარტამენტის დასახელება",
    "institution": "ორგანიზაციის დასახელება",
    "institutionName": "ორგანიზაციის დასახელება",
    "noReassignmentTarget": "ეს არის ორგანიზაციის ერთადერთი დეპარტამენტი. შექმენით სხვა დეპარტამენტი ამის წაშლამდე.",
    "reassignTo": "გადატანა დეპარტამენტში",
    "restore": "აღდგენა",
    "restoredDepartment": "დეპარტამენტი აღდგენილია",
    "searchDepartments": "დეპარტამენტ(ებ)ის ძიება",
    "showArchived": "დაარქივებული დეპარტამენტების ჩვენება",
    "thisFieldIsRequired": "ეს ველი აუცილებელია"
  },
  "general": {
    "add": "დამატება",
    "cancel": "გაუქმება",
    "dateAdded": "თარიღი დამატებულია",
    "dateUpdated": "თარიღი განახლებულია",
    "delete": "წაშლა",
    "edit": "რედაქტირება",
    "loading": "ინვირთება ...",
    "no": "არა",
    "noData": "მონაცემები არაა",
    "ok": "Ok",
    "remove": "მოცილება",
    "save": "შენახვა",
    "selectAll": "ყველას არჩევა",
    "yes": "დიახ",
    "selectGender": "სქესის არჩევა",
    "gender": {
      "male": "მამრობითი",
      "female": "მდედრობითი"
    },
    "action": "მოქმედება",
    "created": "შექმნილია",
    "updated": "განახლებულია",
    "deleted": "წაშლილია",
    "enabled": "ჩართულია",
    "noHistory": "ისტორია არ არსებობს"
  },
  "menu": {
    "categories": "კატეგორიები",
    "departments": "დეპარტამენტები",
    "home": "სახლი",
    "procedures": "პროცედურები",
    "manageProcedures": "პროცედურების მართვა",
    "manageCategories": "კატეგორიების მართვა",
    "scheduling": "დაგეგმვა",
    "users": "მომხმარებლები"
  },
  "device": {
    "udi": "UDI"
  },
  "procedure": {
    "allSteps": "ყველა ნაბიჯი",
    "authors": "ავტორ(ებ)ი",
    "category": "კატეგორია",
    "createNewStep": "ახალი ნაბიჯის შექმნა",
    "defineFeedback": "უკუკავშირის განსაზღვრა",
    "description": "აღწერა",
    "disableProcedure": "პროცედურის გამორთვა",
    "addProceduresInformation": "პროცედურის ინფორმაციის დამატება",
    "editProceduresInformation": "პროცედურის ინფორმაციის რედაქტირება",
    "duplicateStartEndStepWarning": "დაშვებულია მხოლოდ 1 საწყისი და 1 საბოლოო ნაბიჯი",
    "information": "ინფორმაცია",
    "language": "ენა",
    "languagesAvailable": "ხელმისაწვდომი ენები",
    "media": "მედია",
    "name": "დასახელება",
    "owner": "მფლობელი",
    "procedureCategory": "პროცედურის კატეგორია",
    "procedureLanguage": "პროცედურის ენა",
    "procedureName": "პროცედურის დასახელება",
    "procedureNotFound": "პროცედურა ვერ მოინახა",
    "public": "საერთო",
    "publicPrivate": "საერთო/პირადი",
    "revisionHistory": "ცვლილებების ისტორია",
    "searchSteps": "ნაბიჯების ძიება",
    "seeFeedback": "უკუკავშირის ნახვა",
    "statistics": "სტატისტიკა",
    "step": "ნაბიჯი",
    "thisFieldIsRequired": "ეს ველი აუცილებელია",
    "viewAs": "ნახვა როგორც",
    "checklist": "საკონტროლო სია",
    "status": "სტატუსი",
    "revisionDate": "თარიღი",
    "revisionUser": "მომხმარებელი",
    "revisionChanges": "ცვლილებები",
    "revisionStepAdded": "დაემატა",
    "revisionStepRemoved": "წაიშალა",
    "revisionStepUpdated": "განახლდა",
    "revisionStepReordered": "თანმიმდევრობა შეიცვალა"
  },
  "procedures": {
    "addProcedure": "პროცედურის დამატება",
    "category": "კატეგორია",
    "deleteProcedure": "პროცედურის წაშლა",
    "department": "დეპარტამენტი",
    "filter": "ფილტრი",
    "private": "პირადი",
    "procedures": "პროცედურები",
    "public": "საერთო",
    "publicPrivate": "საერთო/პირადი",
    "searchProcedures": "პროცედურების ძებნა",
    "sort": "სორტირება"
  },
  "step": {
    "addDescription": "აღწერის დამატება",
    "addParentStep": "ზედა ნაბიჯის დამატება",
    "chooseParentSep": "აირჩიეთ ზედა ნაბიჯი",
    "chooseStepOption": "აირჩიეთ ნაბიჯის ოპცია",
    "chooseTransitionType": "აირჩიეთ გადასვლის ტიპი",
    "chooseType": "აირჩიეთ ტიპი",
    "description": "აღწერა",
    "dropFilesOrClickToUpload": "ჩაყარეთ ფაილები აქ, ან დააჭირეთ ასატვირთად",
    "editStep": "ნაბიჯის რედაქტირება",
    "insertMaxValue": "მაქსიმალური მნიშვნელობის ჩასმა",
    "insertMinValue": "მინიმალური მნიშვნელობის ჩასმა",
    "insertOption": "ოპციის ჩასმა",
    "option": "ოპცია",
    "owner": "მფლობელი",
    "parentStep": "ზედა ნაბიჯი",
    "previousStep": "წინა ნაბიჯი",
    "saveMedia": "მედიას შენახვა",
    "stepMedia": "მედია ნაბიჯი",
    "transitionToNextStep": "შემდეგ ნაბიჯზე გადასვლა",
    "transitionType": "გადასვლის ტიპი",
    "type": "ტიპი",
    "value": "მნიშვნელობა",
    "viewInProcedure": "პროცედურაში ნახვა",
    "error": {
      "WONT_REACH_END": "დასასრულამდე გზა არ არის",
      "EXIT_NOT_IN_USE": "გამოუყენებელი გამოსასვლელი",
      "NO_PARENT_SET": "წინა ნაბიჯი არ არის",
      "PARENT_NOT_EXITS": "განსაზღვრული მშობელი ნაბიჯი არ არსებობს",
      "DUPLICATE_START": "პროცედურას შეიძლება ჰქონდეს მხოლოდ ერთი საწყისი ნაბიჯი",
      "DUPLICATE_END": "პროცედურას შეიძლება ჰქონდეს მხოლოდ ერთი დასასრული ნაბიჯი",
      "NO_START": "პროცედურას არ აქვს საწყისი ნაბიჯი",
      "NO_END": "პროცედურას არ აქვს დასასრული ნაბიჯი",
      "MULTIPLE_CHILDREN_FOR_EXIT": "გამოსასვლელს იყენებს ერთზე მეტი ნაბიჯი"
    }
  },
  "user": {
    "chooseUserRole": "მომხმარებლის როლის არჩევა",
    "department": "დეპარტამენტი",
    "emails": "მომხმარებლის ეფოსტ(ებ)ი",
    "emailsDescription": "ჩასვით 1 ან მეტი ელფოსტა, გამოყავით მძიმით. არჩეული მომხმარებლის როლად დარეგისტრირების მოსაწვევები მომხმარებლებს ელფოსტით გადაეგზავნებათ.",
    "institution": "ორგანიზაცია",
    "institutionalAdmin": "ორგანიზაციის ადმინისტრატორი",
    "institutionAndDepartment": "ორგანიზაცია და დეპარტამენტი",
    "inviteUsers": "მომხმარებლების მოწვევა",
    "nurse": "ექთანი",
    "patient": "პაციენტი",
    "searchUsers": "მომხმარებლ(ებ)ის ძიება",
    "subscription": "ხელმოწერა",
    "thisFieldIsRequired": "ეს ველი აუცილებელია",
    "user": "მომხმარებელი",
    "userRole": "მომხმარებლის როლი"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  },
  "patients": {
    "standingAssignment": "მუდმივი მინიჭება",
    "noStandingAssignment": "მუდმივი მინიჭება არ არსებობს",
    "unknownNurse": "მიმნიჭებელი ექთანი (სახელი მიუწვდომელია)",
    "standingAssignmentHelperText": "მუდმივ მინიჭებად შესაძლებელია მხოლოდ „საშინაო ექთანი“ როლის მქონე მომხმარებლების არჩევა.",
    "changeStandingAssignment": "მინიჭების შეცვლა",
    "clearStandingAssignment": "მინიჭების გაუქმება",
    "confirmClearStandingAssignmentText": "ნამდვილად გსურთ ამ პაციენტის მუდმივი მინიჭების გაუქმება?",
    "standingAssignmentLabel": "{name} (მუდმივი)",
    "onShiftLabel": "{name} (ცვლაში)",
    "currentlyOnShiftWith": "ამჟამად ცვლაშია თან",
    "notCurrentlyOnShift": "ამჟამად ცვლაში არ არის",
    "visitName": "სახელი",
    "visitDate": "თარიღი",
    "performedBy": "შემსრულებელი",
    "status": "სტატუსი",
    "location": "მდებარეობა / პალატა (არასავალდებულო)",
    "enterLocation": "შეიყვანეთ მდებარეობა ან პალატის ნომერი",
    "admissionDate": "მიღების თარიღი (არასავალდებულო)",
    "dischargeDate": "გაწერის თარიღი (არასავალდებულო)",
    "acuity": "სიმძიმის ხარისხი (არასავალდებულო)",
    "unsupportedFieldsNotice": "ალერგია, მედიკამენტები, სიმაღლე, წონა, პაციენტის ტიპი და მდგომარეობის კოდი/სახელი არ არის მხარდაჭერილი ამ იმპორტით — დაამატეთ ისინი ხელით იმპორტის შემდეგ.",
    "import": {
      "importSucceeded": "{created} პაციენტი დაიმპორტდა, {duplicates} დუბლიკატი გამოტოვებულია.",
      "departmentsLoadFailed": "დეპარტამენტების ჩატვირთვა ვერ მოხერხდა. გთხოვთ, სცადოთ ხელახლა."
    }
  },
  "errors": {
    "UNKNOWN_ERROR": "უცნობი შეცდომა"
  },
  "titles": {
    "categories": "კატეგორიები",
    "visitreport": "ვიზიტის ანგარიში"
  },
  "toasts": {
    "patientAdded": "პაციენტი წარმატებით დაემატა",
    "patientUpdated": "პაციენტი წარმატებით განახლდა",
    "procedureAdded": "პროცედურა წარმატებით დაემატა",
    "procedureUpdated": "პროცედურა წარმატებით განახლდა",
    "procedureDeleted": "პროცედურა წარმატებით წაიშალა",
    "visitAdded": "ვიზიტი წარმატებით დაემატა",
    "visitUpdated": "ვიზიტი წარმატებით განახლდა",
    "visitDeleted": "ვიზიტი წარმატებით წაიშალა"
  },
  "studyResults": {
    "user": "მომხმარებელი",
    "department": "დეპარტამენტი",
    "study": "კვლევა",
    "date": "თარიღი",
    "survey": "გამოკითხვა",
    "results": "შედეგები",
    "studyResults": "კვლევის შედეგები",
    "surveyResults": "გამოკითხვის შედეგები",
    "list": "სია",
    "graph": "გრაფიკი",
    "surveyStartDate": "გამოკითხვის დაწყება",
    "surveyEndDate": "გამოკითხვის დასრულება",
    "userResults": "მომხმარებლის შედეგები",
    "question": "კითხვა",
    "questionType": "კითხვის ტიპი",
    "answer": "პასუხი",
    "position": "პოზიცია",
    "scaleAnswerFormat": "{value} — {meaning}"
  },
  "visitReport": {
    "consent": "თანხმობა",
    "viewConsent": "თანხმობის ნახვა",
    "homeVisit": "ვიზიტი სახლში",
    "recomendationForTreatment": "რეკომენდაციები მკურნალობის, მოვლის, სამუშაოსა და ამბულატორიული ზედამხედველობისთვის",
    "anamnesis": "ანამნეზი",
    "answerType": "პასუხის ტიპი",
    "contactPhone": "საკონტაქტო ტელეფონი",
    "contactEmail": "საკონტაქტო ელფოსტა",
    "visitMadeBy": "ვიზიტი განახორციელა",
    "homeVisitTime": "ვიზიტის დრო სახლში",
    "visitForm": "ვიზიტის ფორმა",
    "viewHistory": "ისტორიის ნახვა",
    "patientsPrimaryHealthConcern": "პაციენტის ძირითადი ჯანმრთელობის პრობლემა",
    "conditionAssesmentInformation": "მდგომარეობის შეფასების ინფორმაცია",
    "bloodPressure": "არტერიული წნევა",
    "measurement": "გაზომვა",
    "BMI": "სხეულის მასის ინდექსი",
    "diagnosis": "დიაგნოზი",
    "appliedMedicalTreatments": "გამოყენებული მედიკამენტური მკურნალობა",
    "appliedTreatment": "გამოყენებული მკურნალობა",
    "descriptionOfTestsConsultationPlans": "ტესტების/კონსულტაციის გეგმების აღწერა",
    "instrumentalTests": "ინსტრუმენტული გამოკვლევები",
    "laboratoryTests": "ლაბორატორიული გამოკვლევები",
    "appliedMedicalTreatment": "გამოყენებული სამედიცინო მკურნალობა",
    "specialist": "სპეციალისტი",
    "status": "სტატუსი",
    "complaintData": "საჩივრის მონაცემები",
    "pulse": "პულსი",
    "viewFullVisitForm": "სრული ვიზიტის ფორმის ნახვა",
    "height": "სიმაღლე",
    "weight": "წონა"
  },
  "institution": {
    "accessRevoked": "თქვენი ორგანიზაცია წაშლილია. თქვენ გამოხვედით სისტემიდან.",
    "confirms": {
      "deleteText": "ეს დამალავს ორგანიზაციას და მის დეპარტამენტებს ადმინისტრაციული პანელიდან და დაუყოვნებლივ გაუუქმებს წვდომას მთელ პერსონალს. ეს შესაძლებელია გაუქმდეს ორგანიზაციის აღდგენით.",
      "deleteTitle": "წავშალოთ {name}?",
      "restoreText": "ეს ხელახლა გახდის ორგანიზაციასა და მის დეპარტამენტებს ხილულს და აღადგენს წვდომას პერსონალისთვის.",
      "restoreTitle": "აღვადგინოთ {name}?"
    },
    "deletedInstitution": "ორგანიზაცია წაშლილია",
    "deleteInstitution": "ორგანიზაციის წაშლა",
    "restore": "აღდგენა",
    "restoredInstitution": "ორგანიზაცია აღდგენილია",
    "showArchived": "დაარქივებული ორგანიზაციების ჩვენება"
  },
  "category": {
    "addCategory": "კატეგორიის დამატება",
    "confirms": {
      "deleteTitle": "წაშალოთ {name}?",
      "deleteTextImmediate": "ამ კატეგორიას არ აქვს პროცედურები და შესაძლებელია მისი დაუყოვნებლივი წაშლა. ეს მოქმედება შეუქცევადია.",
      "chooseReassignMode": "ამ კატეგორიას ჯერ კიდევ აქვს პროცედურები. აირჩიეთ, როგორ გადაანაწილოთ ისინი წაშლამდე.",
      "deleteTextAllAtOnce": "აირჩიეთ კატეგორია, სადაც გადავანაწილებთ ყველა პროცედურას. ეს მოქმედება შეუქცევადია.",
      "deleteTextOneByOne": "გადახედეთ ქვემოთ მოცემულ პროცედურებს და შემდეგ აირჩიეთ კატეგორია, სადაც ისინი ყველა გადავანაწილებთ.",
      "affectedProcedures": "პროცედურები, რომლებიც გადავინაცვლებთ",
      "stillHasProcedures": "ამ კატეგორიას ჯერ კიდევ აქვს მინიჭებული პროცედურები. გთხოვთ, აირჩიოთ სამიზნე კატეგორია."
    },
    "deletedCategory": "კატეგორია წაშლილია",
    "editCategory": "კატეგორიის რედაქტირება",
    "frequency": "სიხშირე",
    "reassignAllAtOnce": "ყველა პროცედურის ერთდროულად გადანაწილება",
    "reassignOneByOne": "გადანაწილება ერთმანეთის მიხედვით",
    "reassignTo": "გადანაწილება",
    "searchCategories": "კატეგორიების ძებნა",
    "updatedCategory": "კატეგორია განახლდა"
  }
}
